/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_App_Price_NoteInputs */

const en_price_page_app_price_note = /** @type {(inputs: Price_Page_App_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a month, or 249 zł a year`)
};

const pl_price_page_app_price_note = /** @type {(inputs: Price_Page_App_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`miesięcznie albo 249 zł rocznie`)
};

/**
* | output |
* | --- |
* | "a month, or 249 zł a year" |
*
* @param {Price_Page_App_Price_NoteInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_app_price_note = /** @type {((inputs?: Price_Page_App_Price_NoteInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_App_Price_NoteInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_app_price_note(inputs)
	return en_price_page_app_price_note(inputs)
});